<script>
	// import LL from '$i18n/i18n-svelte';
	// import SEO from '$lib/components/SEO.svelte';
	// import Globe from '$lib/components/Globe.svelte';
	import ElectionChoropleth from '$lib/components/ElectionChoropleth.svelte';
	import Navbar from '$lib/components/Navbar.svelte';
</script>

<!-- <SEO
	title="Home page"
	description="This is my awesome website"
	url="https://sveltekit-starter.vercel.app"
	image="https://user-images.githubusercontent.com/11630812/114088279-7cd7be80-98d2-11eb-883c-66c3bf48f293.png"
	imageAlt="A beautiful image"
	type="website"
/> -->

<!-- <div class="flex flex-col justify-center items-center" >
	<h1 class="py-8 mx-auto text-6xl font-bold font-title text-accent">Atlas of Elections Demo</h1>
	<h2 class="pb-4 text-xl text-center">Half the world is heading to the polls in 2024. Atlas of Elections will tell you all you need to know about who's running and who's winning through interactive data visualisations.</h2>
</div>
<Globe /> -->
<!-- <h2 class="text-xl font-bold">{$LL.welcome({ year: 2023 })}</h2> -->

<Navbar />

<main class="flex flex-col justify-center items-center w-full min-h-screen">
	<ElectionChoropleth />
</main>
